import { fetchEncryptGet } from '../../providers/Fetch';

import {
  POI_ERROR,
  POI_REQUEST,
  POI_SUCCESS,
} from './types';

export const poiError = error => ({
  type: POI_ERROR,
  error,
});

export const poiRequest = {
  type: POI_REQUEST,
};

export const poiSuccess = data => ({
  type: POI_SUCCESS,
  data,
});

export const poiFetch = ({ area }) => async (dispatch) => {
  try {
    const url = 'poi';
    dispatch(poiRequest);
    const query = {
      find: {
        code: area,
      },
      select: ['_id'],
    };
    const data = await fetchEncryptGet(url, query);
    if (!(Array.isArray(data) && data.length > 0)) {
      throw new Error('Error occured at fetching area data');
    }
    dispatch(poiSuccess(data[0]._id));
  } catch (error) {
    dispatch(poiError(error.message));
  }
};
